import { gql } from '@apollo/client';
import { NEW_ACTION } from '../../fragments/action';

export const FETCH_ACTIONS = gql`
  query FetchActions($input: FilterActionList!) {
    actions(input: $input) {
      actions { ...NewAction }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${NEW_ACTION}
`;

export const GET_ACTION_BY_ID = gql`
  query getActionById($id: ID!) {
    action(id: $id) { ...NewAction }
  }
  ${NEW_ACTION}
`;

// «Convertir actuación» (QA T5, 15-oct): lo que el modal de «Transferir»
// necesita saber para ofrecer el otro mundo y que la tarjeta no trae —si está
// validada y si lleva trabajos externos o fauna—. Query PROPIA y pequeña: no se
// toca el fragment NewAction (lo usan decenas de mocks E2E).
export const GET_ACTION_CONVERT_INFO = gql`
  query GetActionConvertInfo($id: ID!) {
    action(id: $id) {
      id
      isValidate
      isExternal
      externalWorksIDs
      animalUnitIDs
    }
  }
`;

// Warm-up de caché para el detalle de OT/campaña: resuelve N Actions en UNA
// query servidor (backend `actionsByIds`, tenant-scoped, máx 200 ids, orden de
// salida NO garantizado — irrelevante: solo interesa poblar la caché
// normalizada). Usa EXACTAMENTE el fragment NewAction (el mismo de
// GET_ACTION_BY_ID) para que los `client.query(GET_ACTION_BY_ID, cache-first)`
// per-row den hit vía el redirect `Query.action → toReference` de policies.ts.
// ⚠️ NO confundir con GET_ACTIONS_BY_IDS de abajo (readActions @client).
// ⚠️ NUNCA añadir `isBasic` aquí: es @ResolveField que lee `action.tenantId`
// del padre y el select del batch backend NO lo proyecta (devolvería null
// silencioso). El fragment NewAction no lo pide y NADIE en el front lo
// consume (grep 2026-07-21: 0 usos) — si algún día hace falta, es cambio
// backend (añadir tenantId al select) + query aparte.
export const ACTIONS_BY_IDS_WARMUP = gql`
  query ActionsByIds($ids: [ID!]!) {
    actionsByIds(ids: $ids) { ...NewAction }
  }
  ${NEW_ACTION}
`;

/**
 * @client query: lee Actions desde la Apollo cache por IDs.
 *
 * Resolver en `policies.ts → Query.fields.readActions` devuelve refs
 * `Action:<id>` + un campo computado `roid` extraído del Order parental
 * (Action.orderIDs[0] → Order.roid). El resto de campos vienen del
 * fragment `NEW_ACTION` ya almacenado en cache por FETCH_ACTIONS.
 */
export const GET_ACTIONS_BY_IDS = gql`
  query GetActionsByIds($ids: [ID!]!) {
    readActions(ids: $ids) @client {
      ...NewAction
      roid
    }
  }
  ${NEW_ACTION}
`;

/**
 * T99: tras cambiar state de un Order Action a Validated o
 * PendingCertification vía UPDATE_ORDER (ChangeStateModal), el frontend
 * llama esta query para saber si todas las actions del expediente están
 * "listas" → mostrar modal "¿Cerrar OT?".
 *
 * Reutiliza la lógica oficial backend `checkAllActionsValidated`:
 *   - `validated` o `pending-certification` cuentan como OK
 *   - `annulled` se ignoran
 *   - parent debe estar en estado abierto (no End/Annulled)
 *
 * @see ChangeStateModal/index.tsx — invoca esta query post UPDATE_ORDER
 * @see ActionsValidation/Animals/Action/saveData.ts — flujo equivalente
 *      pero vía SAVE_ACTION (que ya devuelve los flags inline).
 */
export const GET_ACTION_EXPEDITION_CLOSE_INFO = gql`
  query ActionExpeditionCloseInfo($indexExpedition: Int!) {
    actionExpeditionCloseInfo(indexExpedition: $indexExpedition) {
      allActionsValidated
      parentOrderId
      parentRoid
      canCloseActions
    }
  }
`;
